import CommunityHubPage from '@/modules/community-hub/community-hub-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/communities')({
  component: CommunityHubPage,
});
